import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import { useTrust } from "../../../lib/context/TrustContext";
import PaymentAdvice from "./PaymentAdvice";
import { API, get } from "../../../config";
import ReceiptTemplate from "./ReceiptTemplate";

const tabsKey = [
  {
    name: "Remittance Advice",
    tabName: "payment-advice",
    value: 1,
  },
  {
    name: "Receipt Title",
    tabName: "receipt",
    value: 2,
  },
];

const TemplateSettings = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "payment-advice";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const [templateData, setTemplateData] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { trustId } = useTrust();

  const fetchTemplateData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await get(`${API.TEMPLATE_DETAILS}/${trustId}`);
      setTemplateData(data?.data);
      setLoading(false);
    } catch (e) {
      setTemplateData("");
      setLoading(false);
    }
  }, [trustId]);

  useEffect(() => {
    fetchTemplateData();
  }, [fetchTemplateData]);

  useEffect(() => {
    navigate(
      `/trusts/${trustId}/trust-general-settings?tab=template&childTab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      }
    );
  }, [activeTab, navigate, trustId]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody search={false} loading={loading} innerBody={true}>
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative p-0 border-none`}
        >
          {activeTab === 1 ? (
            <PaymentAdvice
              templateData={templateData?.payment_advice}
              fetchTemplateData={fetchTemplateData}
              setLoading={setLoading}
              trustId={trustId}
            />
          ) : activeTab === 2 ? (
            <ReceiptTemplate
              templateData={templateData?.receipt}
              receipt_template_type={templateData?.receipt_template_type}
              fetchTemplateData={fetchTemplateData}
              setLoading={setLoading}
              trustId={trustId}
            />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default TemplateSettings;
